export function renderHtml(text){ return {__html: text}; };